var _circle, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66663,
    y: 6.66666,
    width: 10.6667,
    height: 10.6667,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_97_39",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_97_39",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADCElEQVRYCe2Y3U7bQBCFo1aKxG1fm2t4A9L2Eu6gvBASqI+QnhN5KrCy9q5/1jvjg2YY7F1ndr4vQYjDQV8iIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIAIiIALDBI5Yvkf+7fIOlfdQQgdnbGLuW2A+9/IR1zwgSsjgbE+YrD83WeB23XhHu/5BeB1VQgo+ZyYL4KgbH2jH5tcymoQh+Jx/EwH82LF5KqNIGIPP+ckC78e6kXMw7xKan/E7nJ+QfBek8hnrN0hvwTO/4NCpuXj/AetkgLJd8ADRJLiBb9ojSXAHP5IEt/AjSHAP37OEMPA9SggH35OEsPA9SAgPv2UJu4HfooTdwW9Jwm7htyBh9/C3lCD4Rr+rNf93JPgd9H6pIUHw+9R712tKEPwe7NTlGhIEP0U7cX9JCYKfgDx2ewkJgj9GeWR9jgTBH4GbuzxFguDn0s3cVyJB8DOhlm7LkfAHL/qKPA/kA9b4WiiKUgIEd8JDQ4CH1gQf8ObGVAmCP5f8p+dLJQj+J3hL/UgJv/FiQ79yuPYLe7gXpf341v4R/5/wiJ9+IMeCe7h3bJ/WCwjcYO8Lku/wnHzGXj6DophLgCBL4JsgSZhLHs9PhS8JgDc3cuCf0OQn0oBfq/okAFBp5MC3PzX5Fw9FXINv9yShwEAJfHtZSTASM+sU+NZSEozExDoHvrWUBCNRWJeAby0lwUhk1iXhW0tJMBIjdQ341lISjESirgnfWkqCkejVGvCtpSQYia7WhN+1PEhCR2IL+F1rSdgS/u4ltAB/txJagr87CS3C342EluGHl+ABflgJnuCHk+ARfhgJnuG7lxABvlsJkeC7kxARvhsJR5z0CXkeyEescR+Ky+DZm53xFkgjw8d4l8iRQBaXzTW/vaNZSoD3dz5G+xJjEsjiywM1Lj7Q5JqAaPAx5iWGJGwigB+7voCo8C8G8C0lgSywXDd4mHu0fOvyDpX3UEIHZ9zj3KGlajgREAEREAEREAEREAEREAEREAEREAEREAEREIG1CfwDxKYcHPWobPIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.9c3a1310141a8d167c7185081d2bc961.svg";
export { ForwardRef as ReactComponent };